var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12V16C6 17.1046 6.89543 18 8 18H16C17.1046 18 18 17.1046 18 16V12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6V4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4H16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreCap);
export default __webpack_public_path__ + "static/media/store-cap.62bf486e115f28aa2f55ede648954a40.svg";
export { ForwardRef as ReactComponent };